module.exports = __webpack_public_path__ + "img/12_47.d3913051.png";